export default "__VITE_ASSET__DTOU9NhV__";